import React from "react";
import HeadTeacher from "../component/Teachers/HeadTeacher";
import Teacher from "../component/Teachers/Teacher";



export default function Faculties() {
  return (
    <>
      <HeadTeacher />
      <Teacher />
    </>
  );
}
